<ng-container matColumnDef="maintenanceType">
  <mat-header-cell [crud-column-header]="columns.column('maintenanceType')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MaintenanceAspect.maintenanceType">
      Maintenance Type 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'maintenanceType', maintenanceAspectGetter, previousRevisionGetter)">
    {{maintenanceAspectGetter(element)?.maintenanceType}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="periodicMaintenance">
  <mat-header-cell [crud-column-header]="columns.column('periodicMaintenance')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MaintenanceAspect.periodicMaintenance">
      Periodic Maintenance 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'periodicMaintenance', maintenanceAspectGetter, previousRevisionGetter)">
    <mat-icon *ngIf="maintenanceAspectGetter(element)?.periodicMaintenance">check_box</mat-icon><mat-icon *ngIf="maintenanceAspectGetter(element)?.periodicMaintenance == false">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="periodicMaintenanceDays">
  <mat-header-cell [crud-column-header]="columns.column('periodicMaintenanceDays')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MaintenanceAspect.periodicMaintenanceDays">
      Periodic Maintenance Days 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'periodicMaintenanceDays', maintenanceAspectGetter, previousRevisionGetter)">
    {{maintenanceAspectGetter(element)?.periodicMaintenanceDays | number:'1.0-2':'en-GB'}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="routineMaintenance">
  <mat-header-cell [crud-column-header]="columns.column('routineMaintenance')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MaintenanceAspect.routineMaintenance">
      Routine Maintenance 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'routineMaintenance', maintenanceAspectGetter, previousRevisionGetter)">
    <mat-icon *ngIf="maintenanceAspectGetter(element)?.routineMaintenance">check_box</mat-icon><mat-icon *ngIf="maintenanceAspectGetter(element)?.routineMaintenance == false">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="routineMaintenanceDays">
  <mat-header-cell [crud-column-header]="columns.column('routineMaintenanceDays')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MaintenanceAspect.routineMaintenanceDays">
      Routine Maintenance Days 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'routineMaintenanceDays', maintenanceAspectGetter, previousRevisionGetter)">
    {{maintenanceAspectGetter(element)?.routineMaintenanceDays | number:'1.0-2':'en-GB'}}
  </mat-cell>
</ng-container>  

<ng-container matColumnDef="visualInspection">
  <mat-header-cell [crud-column-header]="columns.column('visualInspection')" *matHeaderCellDef 
    mat-sort-header cdkDropList cdkDropListLockAxis="x"
    cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
    class="search-column-small" i18n="@@type.MaintenanceAspect.visualInspection">
      Visual Inspection 
    </mat-header-cell>
  <mat-cell class="search-column-small" *matCellDef="let element" [ngClass]="cellClass(element, 'visualInspection', maintenanceAspectGetter, previousRevisionGetter)">
    <mat-icon *ngIf="maintenanceAspectGetter(element)?.visualInspection">check_box</mat-icon><mat-icon *ngIf="maintenanceAspectGetter(element)?.visualInspection == false">check_box_outline_blank</mat-icon>
  </mat-cell>
</ng-container>  